import { createFeatureSelector } from '@ngrx/store';

export const productRestrictionsState = createFeatureSelector<OLO.State, OLO.State.ProductRestrictions>('productRestrictions');
